<div class="dialog-change" [formGroup]="formGroupChange">
  <h1>Primeiro acesso</h1>
  <h4>
    Este é o seu primeiro acesso. Por favor, altere sua senha para prosseguir no Portal de Vendas.
  </h4>
  <div class="field">
    <h3>Seu Usuário</h3>
    <mat-form-field appearance="outline" FloatLabelType="never">
      <input formControlName="login" matInput placeholder="Seu Usuario"/>
    </mat-form-field>
  </div>
  <div class="field">
    <h3> Sua Senha</h3>
    <mat-form-field appearance="outline" FloatLabelType="never" >
      
      <input
        formControlName="password"
        [type]="visiblePassword.inputType"
        matInput
        placeholder="Digite sua senha"
      />
      <mat-icon
        matSuffix
        class="material-icons material-icons-outlined"
        #visiblePassword="bsVisiblePassword"
        bsVisiblePassword
        >{{ visiblePassword.iconName }}</mat-icon
      >
    </mat-form-field>
  </div>

  <div class="field">
    <h3>Nova Senha</h3>
    <mat-form-field appearance="outline" FloatLabelType="never">
     
      <input
        formControlName="newPassword"
        [type]="visiblePassword.inputType"
        matInput
        placeholder="Digite sua nova senha"
      />
      <mat-icon
        matSuffix
        class="material-icons material-icons-outlined"
        #visiblePassword="bsVisiblePassword"
        bsVisiblePassword
        >{{ visiblePassword.iconName }}</mat-icon
        >
      </mat-form-field>
  </div>
  <div class="field">
    <button
    primary-button="pv-primary"
    [disabled]="formGroupChange.invalid"
    (click)="submitForm.emit(formGroupChange)"
  >
  Alterar
</button>
  </div>
</div>
